export var DateSectionType;
(function (DateSectionType) {
    DateSectionType["DD"] = "DD";
    DateSectionType["MM"] = "MM";
    DateSectionType["YYYY"] = "YYYY";
    DateSectionType["HH"] = "HH";
    DateSectionType["mm"] = "mm";
})(DateSectionType || (DateSectionType = {}));
export var DateTimeFormat;
(function (DateTimeFormat) {
    DateTimeFormat["DateTime"] = "DD.MM.YYYY HH:mm";
    DateTimeFormat["Date"] = "DD.MM.YYYY";
    DateTimeFormat["Time"] = "HH:mm";
})(DateTimeFormat || (DateTimeFormat = {}));
const FORMAT_SECTIONS = {
    [DateTimeFormat.DateTime]: [
        { type: DateSectionType.DD, separatorAfter: '.' },
        { type: DateSectionType.MM, separatorAfter: '.' },
        { type: DateSectionType.YYYY, separatorAfter: ' ' },
        { type: DateSectionType.HH, separatorAfter: ':' },
        { type: DateSectionType.mm }
    ],
    [DateTimeFormat.Date]: [
        { type: DateSectionType.DD, separatorAfter: '.' },
        { type: DateSectionType.MM, separatorAfter: '.' },
        { type: DateSectionType.YYYY }
    ],
    [DateTimeFormat.Time]: [{ type: DateSectionType.HH, separatorAfter: ':' }, { type: DateSectionType.mm }]
};
export function getSectionOrder(format) {
    return FORMAT_SECTIONS[format];
}
export const SECTION_PLACEHOLDERS = {
    [DateSectionType.DD]: 'dd',
    [DateSectionType.MM]: 'mm',
    [DateSectionType.YYYY]: 'yyyy',
    [DateSectionType.HH]: 'hh',
    [DateSectionType.mm]: 'mm'
};
export const SECTION_MAX_LENGTH = {
    [DateSectionType.DD]: 2,
    [DateSectionType.MM]: 2,
    [DateSectionType.YYYY]: 4,
    [DateSectionType.HH]: 2,
    [DateSectionType.mm]: 2
};
export const SECTION_RANGES = {
    [DateSectionType.DD]: { min: 1, max: 31 },
    [DateSectionType.MM]: { min: 1, max: 12 },
    [DateSectionType.YYYY]: { min: 0, max: 9999 },
    [DateSectionType.HH]: { min: 0, max: 23 },
    [DateSectionType.mm]: { min: 0, max: 59 }
};
